<template>
    <div>
      <Pos_paper_tax_invoices/>
    </div>
  </template>
  
  <script>
  import Pos_paper_tax_invoices from "@/components/adminArin/pos_system/pos/Pos_paper_tax_invoices";
  export default {
    name: "PosPaperTaxInvoices",
    components: {
      Pos_paper_tax_invoices
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  